import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ROUTE_NAME_MAP } from './constants';
@Injectable({
  providedIn: 'root'
})
export class PageTrackerService {

  constructor(private router: Router) { }

  private routeNameMap = ROUTE_NAME_MAP;

  startTracking() {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event) => {
      const navEndEvent = event as NavigationEnd;
      const visitedPages = JSON.parse(sessionStorage.getItem('visitedPages') || '[]');
      const url = navEndEvent.urlAfterRedirects;
      const pageName = this.routeNameMap[url] || 'Page Not Found';
      visitedPages.push({
        url: url,
        pageName: pageName,
        timestamp: new Date().toISOString()
      });
      sessionStorage.setItem('visitedPages', JSON.stringify(visitedPages));
    });
  }
  getVisitedPages() {
    return JSON.parse(sessionStorage.getItem('visitedPages') || '[]');
  }
  clearVisitedPages() {
    sessionStorage.removeItem('visitedPages');
  }
}
